export default "/fonts/vendor/primeicons/primeicons.woff?10d3152104f2208ac82ab02dfc65cfb6";